import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { Button } from "antd";
import { useLangNavigate } from "../../../../hooks/useLangNavigate";

const CartFooter = (props) => {
  const { cart = [], login } = props;
  const { t } = useTranslation();

  const navigate = useLangNavigate();

  return (
    <div className="page-fixed-footer-container">
      <Button
        style={{
          width: "100%",
        }}
        type="primary"
        size="large"
        onClick={() => {
          if (!cart.length >= 1) {
            navigate("/");
            return;
          }
          if (!login.is_login) navigate("/login/p/");
          else navigate(login.is_login ? "/delivery/" : "/login/c/");
        }}
      >
        {t("common.next")}
      </Button>
    </div>
  );
};

CartFooter.propTypes = {
  cart: PropTypes.array,
  login: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    login: state.Login,
  };
};

export default connect(mapStateToProps)(CartFooter);
